import { Stats, PatternItem } from "./Stats";
import React from "react";


export const ParityStats = ({dataList, gameName}) => {
    console.log('Rendering ParityStats')
    const patternFunc = (results) => {
        return results.map((result, index) => result % 2 === 0 ? <PatternItem key={index} color="#00ff5a">E</PatternItem>: <PatternItem key={index} color="#ff9900">O</PatternItem>)
    }

    const ratioFunc = (results) => {
        const evenCount = results.filter((result) => result % 2 === 0).length
        return `${evenCount} : ${results.length - evenCount}`
    }

    return (
        <Stats
            dataList={dataList}
            patternFunc={patternFunc}
            ratioFunc={ratioFunc}
            gameName={gameName}
        />
    )
}

